import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useLoading } from './LoadingContext';

const Callback: React.FC = () => {
  const { oktaAuth } = useOktaAuth();
  const { setLoading } = useLoading();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        setLoading(true);
        const tokensResponse = await oktaAuth.token.parseFromUrl();
        const { tokens } = tokensResponse;

        if (tokens?.accessToken && tokens?.idToken) {
          setIsAuthenticated(true);
          sessionStorage.setItem('isAuthenticated', 'true');
          sessionStorage.setItem('idToken', JSON.stringify(tokens.idToken));
        } else {
          console.error('No valid tokens received.');
        }
      } catch (error: any) {
        console.error('Error during token parsing:', error);

        if (error.name === 'AuthSdkError' && error.message?.includes('codeVerifier')) {
          sessionStorage.clear();
          oktaAuth.signInWithRedirect();
        }
      } finally {
        setLoading(false);
      }
    };

    checkAuthentication();
  }, [oktaAuth, setLoading]);

  useEffect(() => {
    if (isAuthenticated) {
      const customToken = localStorage.getItem('customToken');
      const redirectUrl = customToken ? `/?token=${customToken}` : '/';
      
      window.history.replaceState({}, document.title, '/');
      window.location.replace(redirectUrl);
    }
  }, [isAuthenticated]);

  return null;
};

export default Callback;
